import { render, staticRenderFns } from "./part-flight.vue?vue&type=template&id=6911af24&scoped=true&lang=pug"
import script from "./part-flight.vue?vue&type=script&lang=js"
export * from "./part-flight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6911af24",
  null
  
)

export default component.exports